var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "jushuitanStudy" } },
    [
      _c(
        "el-tabs",
        {
          attrs: { "tab-position": "left" },
          on: { "tab-click": _vm.handleTabClick },
          model: {
            value: _vm.tabCurrent,
            callback: function($$v) {
              _vm.tabCurrent = $$v
            },
            expression: "tabCurrent"
          }
        },
        _vm._l(_vm.chapters, function(chapter) {
          return _c(
            "el-tab-pane",
            { key: chapter.key, attrs: { name: chapter.key } },
            [
              _c(
                "div",
                {
                  staticClass: "tab-slot",
                  attrs: { slot: "label" },
                  slot: "label"
                },
                [
                  _c("p", { staticClass: "title" }, [
                    _vm._v(_vm._s(chapter.title))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "hover-con" }, [
                    _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                    _vm._v(" "),
                    _c("p", [_vm._v("点击学习")])
                  ])
                ]
              ),
              _vm._v(" "),
              chapter.key === "first" && _vm.state.videoGateVisible
                ? _c("div", { staticClass: "startvideo" }, [
                    _c("div", { staticClass: "tip" }, [
                      _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                      _vm._v(" "),
                      _c("p", [
                        _c(
                          "a",
                          {
                            staticClass: "startstudy",
                            on: { click: _vm.startVideo }
                          },
                          [_vm._v("开始学习")]
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.state.practiceVisible,
                      expression: "!state.practiceVisible"
                    }
                  ],
                  staticClass: "video-box"
                },
                [
                  _c(
                    "video",
                    {
                      ref: "video-" + chapter.key,
                      refInFor: true,
                      staticClass: "video",
                      attrs: { src: chapter.videoUrl, controls: "controls" },
                      on: {
                        play: _vm.onVideoPlay,
                        ended: function($event) {
                          return _vm.onVideoEnded(chapter.key)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          您的浏览器不支持 video 标签。\n        "
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _vm.state.videoCompleted && !_vm.state.practiceVisible
                ? _c("div", { staticClass: "stoptip" }, [
                    _c("div", { staticClass: "tip" }, [
                      _c("span", { staticClass: "el-icon-success" }),
                      _vm._v(" "),
                      _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                      _vm._v(" "),
                      _c("p", [
                        _c(
                          "a",
                          {
                            staticClass: "restart",
                            on: { click: _vm.restartVideo }
                          },
                          [
                            _c("i", { staticClass: "el-icon-refresh-left" }),
                            _vm._v("重播")
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "startstudy",
                            on: { click: _vm.startStudy }
                          },
                          [_vm._v("开始实操练习")]
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.state.practiceVisible,
                      expression: "state.practiceVisible"
                    }
                  ],
                  staticClass: "content"
                },
                [
                  _c(
                    "div",
                    { staticClass: "con-left" },
                    [
                      chapter.key === "first"
                        ? _c("JstErpLoginScene", {
                            ref: "scene-" + chapter.key,
                            refInFor: true,
                            on: {
                              "step-change": _vm.onStepChange,
                              "guard-failed": _vm.onGuardFailed,
                              finish: _vm.onFinish
                            }
                          })
                        : chapter.key === "second"
                        ? _c("JstErpSecondScene", {
                            ref: "scene-" + chapter.key,
                            refInFor: true,
                            on: {
                              "step-change": _vm.onStepChange,
                              "guard-failed": _vm.onGuardFailed,
                              finish: _vm.onFinish
                            }
                          })
                        : chapter.key === "third"
                        ? _c("JstErpCreateAftersaleScene", {
                            ref: "scene-" + chapter.key,
                            refInFor: true,
                            on: {
                              "step-change": _vm.onStepChange,
                              "guard-failed": _vm.onGuardFailed,
                              finish: _vm.onFinish
                            }
                          })
                        : chapter.key === "four"
                        ? _c("JstErpOrderQueryScene", {
                            ref: "scene-" + chapter.key,
                            refInFor: true,
                            on: {
                              "step-change": _vm.onStepChange,
                              "guard-failed": _vm.onGuardFailed,
                              finish: _vm.onFinish
                            }
                          })
                        : _c("JstErpPlaceholderScene")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("aside", { staticClass: "con-right" }, [
                    _c("h3", [
                      _c("span", { staticClass: "line" }),
                      _vm._v("提示")
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      class: {
                        "compact-tip":
                          _vm.tabCurrent === "third" &&
                          _vm.rightTipStep === "create-wrong-exchange"
                      },
                      domProps: { innerHTML: _vm._s(_vm.rightTip) }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _vm.state.practiceCompleted
                ? _c("div", { staticClass: "stoptip practice-finish" }, [
                    _c("div", { staticClass: "tip" }, [
                      _c("span", { staticClass: "el-icon-success" }),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.isLastChapter
                              ? "聚水潭实操完成"
                              : "实操通关，进入下一关吧"
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _c(
                          "a",
                          {
                            staticClass: "restart",
                            on: { click: _vm.restartStudy }
                          },
                          [
                            _c("i", { staticClass: "el-icon-refresh-left" }),
                            _vm._v("重练")
                          ]
                        ),
                        _vm._v(" "),
                        !_vm.isLastChapter
                          ? _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                on: { click: _vm.studyNext }
                              },
                              [_vm._v("GO，下一关")]
                            )
                          : _vm._e()
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "study-box" },
                [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("查看学习资料")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c("el-col", { attrs: { span: 20 } }, [
                        _c("img", {
                          staticClass: "img-box",
                          attrs: {
                            src: require("@/assets/images/newqianniu/ppt.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "con-box" }, [
                          _c("p", [_vm._v(_vm._s(chapter.pptTitle))]),
                          _vm._v(" "),
                          _c("p", [
                            _vm.isOpenPpt[chapter.key]
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "btn-open",
                                    on: {
                                      click: function($event) {
                                        return _vm.viewPpt(chapter.key, false)
                                      }
                                    }
                                  },
                                  [_vm._v("点击收起")]
                                )
                              : _c(
                                  "a",
                                  {
                                    staticClass: "btn-open",
                                    on: {
                                      click: function($event) {
                                        return _vm.viewPpt(chapter.key)
                                      }
                                    }
                                  },
                                  [_vm._v("点击展开")]
                                )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _vm.state.videoCompleted && !_vm.state.practiceVisible
                            ? _c(
                                "el-button",
                                {
                                  staticClass: "pull-right startbtn",
                                  attrs: { type: "primary" },
                                  on: { click: _vm.startStudy }
                                },
                                [_vm._v("开始练习")]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { attrs: { id: chapter.pdfViewerId } })
                ],
                1
              )
            ]
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60605782", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60605782","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/simulate/juShuiTanErpStudy.vue
// module id = 1382
// module chunks = 0